/* eslint-disable */

import axios from "axios";
import api, { BASE_URL } from "../api";

const state = {
  loading: false,
  pageNum: 0,
  numPages: 0,
  prev: null,
  next: null,
  count: null,
  members: {},
  createError: null
};

// getters
const getters = {};

// actions
const actions = {
  initMembers: context => {
    context.commit("SET_LOADING", true);
    api
      .get(`${BASE_URL}/team/members/`)
      .then(response => response.data)
      .then(data => {
        context.commit("DEFAULT_API_RESPONSE", data);
      })
      .catch(error => {
        console.log(error);
        console.log("ERROR");
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  nextMembers: context => {
    context.commit("SET_LOADING", true);
    api
      .get(context.state.next)
      .then(response => response.data)
      .then(data => {
        context.commit("DEFAULT_API_RESPONSE", data);
      })
      .catch(error => {
        console.log(error);
        console.log("ERROR");
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  prevMembers: context => {
    context.commit("SET_LOADING", true);
    api
      .get(context.state.prev)
      .then(response => response.data)
      .then(data => {
        context.commit("DEFAULT_API_RESPONSE", data);
      })
      .catch(error => {
        console.log(error);
        console.log("ERROR");
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  createMember: (context, newMember) => {
    context.commit("SET_LOADING", true);
    return api
      .post(`${BASE_URL}/team/members/`, newMember)
      .then(response => {
        context.commit("SET_CREATE_ERROR", null);
        return response;
      })
      .catch(error => {
        context.commit("SET_CREATE_ERROR", error);
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  updateMember: (context, updateMember) => {
    context.commit("SET_LOADING", true);
    return api
      .put(`${BASE_URL}/team/members/${updateMember.id}/`, updateMember)
      .then(response => {
        context.commit("SET_CREATE_ERROR", null);
        return response;
      })
      .catch(error => {
        context.commit("SET_CREATE_ERROR", error);
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  }
};

// mutations
const mutations = {
  DEFAULT_API_RESPONSE(state, data) {
    if (!!data.count) {
      state.members = data.results;
      state.pageNum = data.page_num;
      state.numPages = data.num_pages;
      state.count = data.count;
      state.next = data.next;
      state.prev = data.previous;
    } else {
      state.members = data;
      state.pageNum = 0;
      state.numPages = 0;
      state.count = data.length;
      state.next = null;
      state.prev = null;
    }
  },
  SET_NUM_PAGES(state, numPages) {
    state.numPages = numPages;
  },
  SET_PAGE_NUMBER(state, pageNum) {
    state.pageNum = pageNum;
  },
  SET_MEMBERS(state, members) {
    state.members = members;
  },
  SET_COUNT(state, count) {
    state.count = count;
  },
  SET_PREV(state, prev) {
    state.prev = prev;
  },
  SET_NEXT(state, next) {
    state.next = next;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_CREATE_ERROR(state, error) {
    state.createError = error;
  }
};

export default { namespaced: true, state, getters, actions, mutations };
